import { userServiceReq } from '@tshared/oapi/req'

import type { UserUiItem } from '@/rbac'

export const USER_UIS_QUERY_KEY = '/api/user/uis/by-user/{userId}' as const

export async function getUserPermissions(userId: string): Promise<UserUiItem[]> {
  const res = await userServiceReq.GET(USER_UIS_QUERY_KEY, {
    params: { path: { userId } },
  })
  const body = res.data ?? { data: [] }
  return (body.data ?? []).map((u) => ({ key: u.key, route: u.route ?? '' }))
}
